import React, { useState } from "react";
import { RiLightbulbFlashLine } from "react-icons/ri";
import "./LampSuggestion.css";

export function LampSuggestion({ text }: { text: string }) {
  const [lampOn, setLampOn] = useState<boolean>(false);
  return (
    <div className={lampOn ? "flex lamp-box-open" : "flex lamp-box-closed"}>
      <div
        onClick={() => {
          setLampOn(!lampOn);
        }}
      >
        <RiLightbulbFlashLine size={30} className={lampOn ? "lamp-on" : ""} />
      </div>
      {lampOn ? <div>{text}</div> : null}
    </div>
  );
}
